import { render, staticRenderFns } from "./StartList.vue?vue&type=template&id=371d9f70&"
import script from "./StartList.vue?vue&type=script&lang=js&"
export * from "./StartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports